export default __webpack_public_path__ + "static/media/twitter-icon.93578a5e.svg";